module.exports = __webpack_public_path__ + "img/file-box.4b214748.png";